import { SupabaseClient } from '@supabase/supabase-js';
import React, { createContext, useContext } from 'react';

export type GlobalData = {
  supabase: SupabaseClient<any, 'public', any>;
};

export const DataContext = createContext<GlobalData>({} as GlobalData);

export const DataProvider = ({
  children,
  supabase,
}: {
  children: React.ReactNode;
  supabase: SupabaseClient<any, 'public', any>;
}) => {
  return (
    <DataContext.Provider value={{ supabase }}>{children}</DataContext.Provider>
  );
};

export const useData = () => {
  const supabase = useContext(DataContext);
  if (supabase === undefined) {
    throw new Error('useData must be used within a DataProvider');
  }
  return supabase;
};
